import { styled } from '@mui/system'
import { TTheme } from '@/core/theme'

export const SearchInputWrapper = styled('div')<{ theme?: TTheme }>`
    position: relative;
    display: flex;
    align-items: center;
`

export const SearchIconWrapper = styled('div')<{ theme?: TTheme }>`
    position: absolute;
    left: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
`

export const Input = styled('input')<{
    theme?: TTheme
    width?: string
    inputHeight?: string
}>`
    height: ${({ inputHeight }) => inputHeight || '42px'};
    padding: 8px 12px 8px 40px;
    border: 1px solid ${({ theme }) => theme.colors.greys[300]};
    border-radius: 8px;
    width: ${({ width }) => width || '241px'};
    background-color: ${({ theme }) =>
        theme.colors.semantic.backgroundSecondary};
    font-size: var(--font-size-s);
    color: ${({ theme }) => theme.colors.greys[700]};
    &:focus {
        outline: none;
        border: 1px solid ${({ theme }) => theme.colors.greys[300]};
    }

    &::placeholder {
        color: ${({ theme }) => theme.colors.greys[500]};
    }
`
